import { type ReactNode } from "react";

interface ContainerProps {
  children: ReactNode;
  className?: string;
}

const Container = ({ children, className = "" }: ContainerProps) => (
  <div
    className={`mx-auto w-full px-4 py-6 sm:px-6 lg:px-8 xl:px-12 ${className}`}
  >
    {children}
  </div>
);

export default Container;
